/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography, Avatar, Divider } from '@mui/material';
import './RecurringPaymentARModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CompDirection from '../../../themes/CompDirection';
import { themes } from '../../../themes/themes';
import TakeActionSplitBtn from '../../../components/TakeActionSplitBtn/TakeActionSplitBtn';
import { getAmount } from '../../../configs/utils';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../helper';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
  fullData?: any;
  allActions?: any;
  handleSubmitAR_Request?: any;
  userId: any;
}

const RecurringPaymentARModalPresenter = ({
  isModalOpen,
  closeModal,
  fullData,
  trans,
  allActions,
  userId,
  handleSubmitAR_Request,
}: ModalProps) => {
  const handleTakeAction = (x: any) => {
    if (x) {
      const payload = {
        event: 'loans',
        instanceId: fullData?.id,
        userId: userId,
        action: x ? x : '',
        context: {},
        model: 'recurring payment',
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="80vh"
      modalWidth="23vw"
      overflowY="auto"
    >
      <ModalHeader
        modal={{ modal_title: trans('Recurring Payment Action Required') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={12}>
            <Box className="bg_border_ar_recurring">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Avatar src={fullData?.profile_pic} />
                <Box style={{ paddingLeft: '10px' }}>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.darkBlue,
                      fontSize: '1em',
                      fontWeight: 'bold',
                    }}
                  >
                    {fullData?.first_name + ' ' + fullData?.last_name}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.grey_colorDesignationAR,
                      fontSize: '0.825em',
                    }}
                  >
                    {fullData?.department_name} / {fullData?.designation_name}
                  </Typography>
                </Box>
              </Box>

              <Box
                style={{
                  backgroundColor: '#F2E6F0',
                  borderRadius: '4px',
                  padding: '2px',
                  width: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  maxWidth: '80px',
                  marginTop: '1em',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    color: themes.primaryMain,
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                >
                  Addition
                </Typography>
              </Box>

              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: 'auto',
                  borderRadius: '10px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '0.5em',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Submmission Date
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Type
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.725em',
                      fontWeight: 'bold',
                      color: themes.darkBlue,
                    }}
                  >
                    <DateField
                      value={fullData?.start_date}
                      format={baseDateFormatting}
                    />
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.725em',
                      fontWeight: 'bold',
                      color: themes.lightRedSubtittle,
                    }}
                  >
                    {fullData?.loan_type}
                  </Typography>
                </Box>
                <Divider style={{ marginTop: '0.5em' }} />
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '0.5em',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Payment Mode
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Amount
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.725em',
                      fontWeight: 'bold',
                      color: themes.darkBlue,
                    }}
                  >
                    Cash
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.725em',
                      fontWeight: 'bold',
                      color: themes.primaryMain,
                    }}
                  >
                    {getAmount(fullData?.amount)}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Attachment
                  </Typography>
                  <Box>
                    <i className="las la-eye" color={themes.primary} />
                  </Box>
                </Box>
              </Box>

              <Box style={{ marginTop: '1.5em' }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: '1.5em', zIndex: '999', width: '100%' }}>
                <TakeActionSplitBtn
                  onAction={(x: any) => handleTakeAction(x)}
                  menu={allActions}
                  title={'Take Action'}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default RecurringPaymentARModalPresenter;
